import type { TFunction } from 'i18next';
import type { DdsError } from '@/types/core/transit/transit';

export function getDdsErrorMessage(
  error: Pick<DdsError, 'operation' | 'category'> & Partial<DdsError>,
  t: TFunction<'transits'>,
): string {
  if (error.operation === 'amendDds') {
    return t('ddsAmendFailure', {
      reason: getDdsErrorMessage(
        { ...error, operation: 'submitDds', submissionUncertain: false },
        t,
      ),
    });
  }
  if (error.operation === 'submitDds') {
    if (error.messages?.length) {
      return error.messages.join(' ');
    }
    if (error.submissionUncertain) {
      return t('ddsSubmissionUncertain');
    }
  }
  if (error.issues?.length) {
    const messages = error.issues.map((issue) => {
      const reason = t(`ddsPreparationIssues.${issue.code}`, {
        defaultValue: t('ddsPreparationInvalid'),
      });
      return issue.sku
        ? t('ddsPreparationSkuIssue', { sku: issue.sku, reason })
        : reason;
    });
    return [...new Set(messages)].join(' ');
  }
  if (error.rejectionCodes?.length) {
    return error.rejectionCodes
      .map((code) =>
        t(`ddsRejectionCodes.${code}`, {
          defaultValue: t('ddsRejectedByTraces'),
        }),
      )
      .join(' ');
  }
  if (error.operation === 'getDds') {
    return t(`ddsConsultationErrors.${error.category}`, {
      defaultValue: t('ddsConsultationError'),
    });
  }
  if (error.category === 'validation') {
    return t('ddsPreparationIssues.invalid_payload');
  }
  if (
    error.faultType === 'BusinessRulesValidationException' ||
    error.faultType === 'NotFoundException'
  ) {
    return t('ddsRejectedByTraces');
  }
  return t(
    `ddsSubmissionErrors.${error.faultType === 'PermissionDeniedException' ? 'permission_denied' : error.category}`,
    { defaultValue: t('ddsSendError') },
  );
}
